import { render, staticRenderFns } from "./matstatistic.vue?vue&type=template&id=113da194&scoped=true&"
import script from "./matstatistic.vue?vue&type=script&lang=js&"
export * from "./matstatistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113da194",
  null
  
)

export default component.exports